// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RDQOF","fullView":"styles_fullView__phn53"};